module.exports = __webpack_public_path__ + "img/more.0ac0384a.svg";